
// Market-aware price. Do not type a figure into this page again.
// Set synchronously so quiz text can use it immediately, then corrected from the
// live product price, so a price change in Shopify reaches this page on its own.
var ZVP = (function(){
  var S = { USD:'$', GBP:'£', EUR:'€' }, F = { USD:6900, GBP:4900 };
  var c = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  window.ZVP_CODE = c;
  function f(cents){ var v = cents/100; return (S[c] || c + ' ') + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); }
  window.ZVP_FMT = f;
  return f(F[c] || 6900);
})();
fetch('/products/the-pdrn-serum.js', { headers:{ 'Accept':'application/json' } })
  .then(function(r){ return r.ok ? r.json() : null; })
  .then(function(p){ if (p && typeof p.price === 'number') ZVP = window.ZVP_FMT(p.price); })
  .catch(function(){});
var ZVQ_KEY = "XNpMRQ";
var ZVQ_LIST = window.ZVShop.listId;

var ZVQ_STEPS = [
  { k:'age_range', q:'First — roughly how old are you?',
    a:[{v:'34 or under'},{v:'35-44',t:'35 to 44'},{v:'45-54',t:'45 to 54'},{v:'55-64',t:'55 to 64'},{v:'65 or over'}] },

  { k:'skin_concern', q:'When you catch yourself in the mirror, what bothers you most?',
    sub:'One thing. The one that actually nags.',
    a:[{v:'Looking tired when I’m not'},{v:'Fine lines'},{v:'Loss of firmness'},{v:'Dullness, no glow'},{v:'Uneven tone or dark patches'},{v:'Dryness that never settles'}] },

  { k:'concern_duration', q:'How long has that been on your mind?',
    a:[{v:'Under 6 months'},{v:'6 to 12 months'},{v:'1 to 3 years'},{v:'More than 3 years'}] },

  { info:1, n:'A note, halfway', h:'You were choosing with the numbers hidden.',
    p:['A serum can print an ingredient in big letters on the front and include almost none of it. Every word on the box stays technically true, and it is entirely legal.',
       'The percentage is the one number that would let you compare two bottles. It is also the one number almost nobody prints. So if the last one did nothing, that may say more about the box than about your skin.'],
    btn:'Go on' },

  { k:'desired_outcome', q:'If one thing looked different by the autumn, what would you pick?',
    a:[{v:'To look rested'},{v:'To recognise myself in photos'},{v:'Smoother-looking skin'},{v:'Fewer products, less faff'},{v:'To stop thinking about it'}] },

  { k:'tried_before', q:'How many serums have you bought for this and given up on?',
    a:[{v:'None yet'},{v:'One'},{v:'Two or three'},{v:'More than I’d like to admit'}] },

  { k:'tried_result', q:'What happened with the last one?',
    skipIf:function(A){ return A.tried_before === 'None yet'; }, skipVal:'No previous serum',
    a:[{v:'Nothing I could see'},{v:'Something, then it stopped'},{v:'It irritated my skin'},{v:'It was fine, it ran out'}] },

  { info:2, n:'One more thing', h:'Skin works on weeks, not days.',
    p:['This is a daily serum, made for a steady place in your morning and evening routine.',
       'Which makes the last question less trivial than it looks. A routine you keep beats a better routine you drop in a fortnight.'],
    btn:'Last question' },

  { k:'morning_minutes', q:'Honestly — how long do you have in the morning?',
    sub:'Not how long you’d like. How long you actually have.',
    a:[{v:'Under 3 minutes'},{v:'3 to 5 minutes'},{v:'5 to 10 minutes'},{v:'Time isn’t the problem'}] },

  { text:1, k2:'purchase_objection', q:'What would stop you from buying this?',
    sub:'Optional.' },

  { summary:true },
  { signup:true }
];

var ZVQ_A = {};
var ZVQ_i = 0;
var ZVQ_hist = [];

function zvqEl(id){ return document.getElementById(id); }
function zvqEsc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

function zvqTotal(){
  var n = 0;
  for (var i=0;i<ZVQ_STEPS.length;i++){
    var s = ZVQ_STEPS[i];
    if (s.k && !(s.skipIf && s.skipIf(ZVQ_A))) n++;
  }
  return n;
}
function zvqAnswered(){
  var n = 0;
  for (var i=0;i<ZVQ_STEPS.length;i++){
    var s = ZVQ_STEPS[i];
    if (s.k && ZVQ_A[s.k] && ZVQ_A[s.k] !== s.skipVal) n++;
  }
  return n;
}

function zvqBegin(){
  zvqEl('zvqIntro').style.display = 'none';
  zvqEl('zvqRun').style.display = 'block';
  ZVQ_i = 0;
  zvqRender();
}

function zvqAnswer(key, val){ ZVQ_A[key] = val; ZVQ_hist.push(ZVQ_i); ZVQ_i++; zvqRender(); }
function zvqNext(){ ZVQ_hist.push(ZVQ_i); ZVQ_i++; zvqRender(); }
function zvqSaveText(key){
  var t = zvqEl('zvqFree');
  var v = t ? t.value.replace(/^\s+|\s+$/g,'') : '';
  if (v) ZVQ_A[key] = v; else delete ZVQ_A[key];
  zvqNext();
}
function zvqBack(){
  if (!ZVQ_hist.length) return;
  ZVQ_i = ZVQ_hist.pop();
  var s = ZVQ_STEPS[ZVQ_i];
  if (s && s.k) delete ZVQ_A[s.k];
  zvqRender();
}

function zvqRender(){
  var s = ZVQ_STEPS[ZVQ_i];
  while (s && s.k && s.skipIf && s.skipIf(ZVQ_A)) {
    ZVQ_A[s.k] = s.skipVal;
    ZVQ_i++;
    s = ZVQ_STEPS[ZVQ_i];
  }
  var stage = zvqEl('zvqStage');
  var pct = Math.round((zvqAnswered() / zvqTotal()) * 100);
  zvqEl('zvqBar').style.width = pct + '%';

  var h = '';
  if (s.k) {
    h += '<div class="zv-card">';
    h += '<div class="zv-count">Question ' + (zvqAnswered()+1) + ' of ' + zvqTotal() + '</div>';
    h += '<h2 class="zv-qtitle">' + zvqEsc(s.q) + '</h2>';
    if (s.sub) h += '<p class="zv-sub">' + zvqEsc(s.sub) + '</p>';
    for (var i=0;i<s.a.length;i++){
      var o = s.a[i];
      h += '<button type="button" class="zv-opt" onclick="zvqAnswer(\'' + s.k + '\',\'' + zvqEsc(o.v) + '\')">' + zvqEsc(o.t || o.v) + '</button>';
    }
    h += '</div>';
    if (ZVQ_hist.length) h += '<button type="button" class="zv-back" onclick="zvqBack()">Back</button>';
  }
  else if (s.info) {
    h += '<div class="zv-note-card">';
    h += '<div class="zv-num">' + zvqEsc(s.n) + '</div>';
    h += '<h2>' + zvqEsc(s.h) + '</h2>';
    for (var j=0;j<s.p.length;j++) h += '<p>' + zvqEsc(s.p[j]) + '</p>';
    h += '<button type="button" class="zv-go" onclick="zvqNext()">' + zvqEsc(s.btn) + '</button>';
    h += '</div>';
    h += '<button type="button" class="zv-back" onclick="zvqBack()">Back</button>';
  }
  else if (s.text) {
    h += '<div class="zv-card">';
    h += '<h2 class="zv-qtitle">' + zvqEsc(s.q) + '</h2>';
    h += '<p class="zv-sub">' + zvqEsc(s.sub) + '</p>';
    h += '<textarea class="zv-input" id="zvqFree" rows="4">' + zvqEsc(ZVQ_A[s.k2] || '') + '</textarea>';
    h += '<button type="button" class="zv-start" onclick="zvqSaveText(\'' + s.k2 + '\')">Continue</button>';
    h += '</div>';
    h += '<button type="button" class="zv-back" onclick="zvqBack()">Back</button>';
  }
  else if (s.summary) {
    h += '<div class="zv-card">';
    h += '<h2 class="zv-qtitle">Here’s what you told me.</h2>';
    h += '<ul class="zv-echo">' + zvqEcho() + '</ul>';
    h += '<p style="font-size:19px;margin:0 0 22px">I’m not going to turn that into a diagnosis. I don’t know what’s causing it, nobody has used this serum yet, and a made-up verdict is exactly the thing this brand exists to avoid.</p>';
    h += '<p style="font-size:19px;margin:0 0 26px">' + (window.ZVShop.country==='US' ? zvqEsc(zvqEl('zvqReserveEntry').dataset.summary) : 'What it does mean is that you won’t get the same email as everyone else.') + '</p>';
    h += '<button type="button" class="zv-start" onclick="zvqNext()">Carry on</button>';
    h += '</div>';
    h += '<button type="button" class="zv-back" onclick="zvqBack()">Back</button>';
  }
  else if (s.signup && window.ZVShop.country==='US') {
    h = zvqEl('zvqReserveEntry').innerHTML;
  }
  else if (s.signup) {
    h += '<div class="zv-card">';
    h += '<h2 class="zv-qtitle">Want to know when it’s ready?</h2>';
    h += '<p style="font-size:19px;margin:0 0 22px">Nothing to pay to join the list, and no date. A safety assessor still has to sign the whole thing off, and I won’t put a date on that, because a date in an email arrives at your end as a promise.</p>';
    h += (window.ZVShop&&window.ZVShop.country==='GB') ? '<p style="font-size:19px;margin:0 0 22px"><b>No UK delivery yet.</b></p>' : ('<p style="font-size:19px;margin:0 0 22px"><b>' + ZVP + ' at launch.</b> You may as well know that now rather than at the bottom of a checkout page.</p>');
    h += '<p style="font-size:19px;margin:0 0 14px">What you’d be waiting for, in full:</p>';
    h += '<ul class="zv-facts">';
    h += '<li><b>PDRN</b>, the ingredient this category is built on.</li>';
    h += '<li><b>Six peptides</b>, 0.5% each and 3% in total.</li>';
    h += '<li><b>2% niacinamide.</b></li>';
    h += '<li><b>77.8% water</b> — because most of a serum is water and pretending otherwise would be the first lie.</li>';
    h += '<li><b>No added colorants.</b> Both colorants were removed before the first batch.</li>';
    h += '<li><b>Fragrance-free, and no SPF.</b> The perfume came out on purpose.</li>';
    h += '</ul>';
    h += '<div id="zvqForm">';
    h += '<input type="email" class="zv-input" id="zvqEmail" placeholder="Your email address" autocomplete="email" inputmode="email">';
    h += '<button type="button" class="zv-start" id="zvqJoin" onclick="zvqSubmit()">Put me on the list</button>';
    h += '<div class="zv-msg" id="zvqMsg"></div>';
    h += '<p class="zv-small">Already on the list? Use the same address and your answers land on the record you already have, rather than starting a second one.</p>';
    h += '<p class="zv-small">We’ll only email you about the launch, and about the bits that go wrong. Leave the email list any time.</p>';
    h += '</div>';
    h += '<div id="zvqOk" style="display:none">';
    h += '<p style="font-size:22px;margin:0 0 10px">Your signup request was received.</p>';
    h += '<p style="font-size:18px;color:#635C54;margin:0">'+((window.ZVShop&&window.ZVShop.country==='GB')?'You’re on the UK list. Thank you for the two minutes.':'I’ll email you when there’s something real to say, and not before. Thank you for the two minutes.')+'</p>';
    h += '</div>';
    h += '</div>';
    h += '<p class="zv-sign">Julian, ZUVIE</p>';
  }

  stage.innerHTML = h;
  if (window.scrollTo) window.scrollTo(0, 0);
}

function zvqEcho(){
  var A = ZVQ_A, out = [];

  var con = {
    'Looking tired when I’m not': 'What bothers you most is looking tired when you’re not.',
    'Fine lines': 'What bothers you most is fine lines.',
    'Loss of firmness': 'What bothers you most is skin that’s lost its firmness.',
    'Dullness, no glow': 'What bothers you most is dullness.',
    'Uneven tone or dark patches': 'What bothers you most is uneven tone.',
    'Dryness that never settles': 'What bothers you most is dryness that never settles.'
  };
  var dur = {
    'Under 6 months': 'It started fairly recently — under six months.',
    '6 to 12 months': 'It’s been on your mind the best part of a year.',
    '1 to 3 years': 'You’ve been living with it for over a year.',
    'More than 3 years': 'You’ve been living with it for years.'
  };
  var tried = {
    'None yet': 'You haven’t bought a serum for it yet.',
    'One': 'You’ve tried one serum.',
    'Two or three': 'You’ve tried two or three.',
    'More than I’d like to admit': 'You’ve lost count of the bottles.'
  };
  var res = {
    'Nothing I could see': 'The last one did nothing you could see.',
    'Something, then it stopped': 'The last one did something, then stopped.',
    'It irritated my skin': 'The last one didn’t agree with your skin.',
    'It was fine, it ran out': 'The last one was fine. It just ran out.'
  };
  var mins = {
    'Under 3 minutes': 'And you have under three minutes in the morning.',
    '3 to 5 minutes': 'And you have about five minutes in the morning.',
    '5 to 10 minutes': 'And you have five to ten minutes in the morning.',
    'Time isn’t the problem': 'And time in the morning isn’t your problem.'
  };
  var want = {
    'To look rested': 'What you want back is looking rested.',
    'To recognise myself in photos': 'What you want back is recognising yourself in photographs.',
    'Smoother-looking skin': 'What you want is skin that looks smoother.',
    'Fewer products, less faff': 'What you want is fewer products and less faff.',
    'To stop thinking about it': 'What you want is to stop thinking about it.'
  };

  if (con[A.skin_concern]) out.push(con[A.skin_concern]);
  if (dur[A.concern_duration]) out.push(dur[A.concern_duration]);
  if (tried[A.tried_before]) out.push(tried[A.tried_before]);
  if (res[A.tried_result]) out.push(res[A.tried_result]);
  if (want[A.desired_outcome]) out.push(want[A.desired_outcome]);
  if (mins[A.morning_minutes]) out.push(mins[A.morning_minutes]);
  out.push('That’s the reality this is being built for.');

  var h = '';
  for (var i=0;i<out.length;i++) h += '<li>' + out[i] + '</li>';
  return h;
}

function zvqPost(path, body){
  return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + ZVQ_KEY, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
    body: JSON.stringify(body)
  }).then(function(r){
    if (r.status === 202 || r.ok) return true;
    throw new Error(path + ' ' + r.status);
  });
}

function zvqSubmit(){
  if(window.ZVShop.country==='US')return;
  var em = zvqEl('zvqEmail').value.trim();
  var b = zvqEl('zvqJoin');
  var m = zvqEl('zvqMsg');
  m.textContent = '';
  if (!em || em.indexOf('@') < 1 || em.indexOf('.') < 0){
    m.textContent = 'Please enter a valid email address.';
    return;
  }
  b.disabled = true;
  b.textContent = 'One moment…';

  var props = {};
  for (var k in ZVQ_A){ if (ZVQ_A.hasOwnProperty(k)) props[k] = ZVQ_A[k]; }
  props.signup_source = 'quiz';
  props.quiz_source = 'skin-questions';
  props.quiz_completed_at = new Date().toISOString();

  var subPayload = {
    data: {
      type: 'subscription',
      attributes: { profile: { data: { type: 'profile', attributes: { email: em, properties: props } } } },
      relationships: { list: { data: { type: 'list', id: ZVQ_LIST } } }
    }
  };
  // Both calls are required. /client/subscriptions/ sets consent and list membership but
  // writes NO properties onto a profile that already exists (proven 2026-08-11).
  // /client/profiles/ writes the fields on new and existing profiles alike.
  var profPayload = { data: { type: 'profile', attributes: { email: em, properties: props } } };

  zvqPost('subscriptions', subPayload)
    .then(function(){ return zvqPost('profiles', profPayload); })
    .then(function(){
      zvqEl('zvqForm').style.display = 'none';
      zvqEl('zvqOk').style.display = 'block';
      zvqEl('zvqBar').style.width = '100%';
      if (window.fbq) { if (window.ZVAM && typeof window.ZVAM.lead === 'function') { window.ZVAM.lead({}, { email: em }); } else { fbq('track','Lead'); } }
    })
    .catch(function(){
      b.disabled = false;
      b.textContent = 'Put me on the list';
      m.textContent = 'Something went wrong. Please try again.';
    });
}

document.addEventListener('keydown', function(e){
  if (e.key === 'Enter' && document.activeElement && document.activeElement.id === 'zvqEmail') zvqSubmit();
});

;

// Market-aware price. Do not type a figure into this page again.
(function(){
  var SYMBOL = { USD:'$', GBP:'£', EUR:'€' };
  var FIRST_PAINT = { USD:6900, GBP:4900 };
  var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function fmt(cents){
    var v = cents / 100;
    return (SYMBOL[code] || code + ' ') + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function paint(cents){
    window.ZV_PRICE = fmt(cents);
    var n = document.querySelectorAll('.zv-price-auto');
    for (var i = 0; i < n.length; i++) n[i].textContent = window.ZV_PRICE;
  }
  if (FIRST_PAINT[code]) paint(FIRST_PAINT[code]);
  fetch('/products/the-pdrn-serum.js', { headers:{ 'Accept':'application/json' } })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(p){ if (p && typeof p.price === 'number') paint(p.price); })
    .catch(function(){});
})();

